/**
 * O campo de tempo das automações: `HH:MM:SS`, que já vem `00:00:00` e se
 * digita como num cronômetro — os números entram pela direita ("130" vira
 * 00:01:30). Ao sair do campo, minuto ou segundo acima de 59 vira o que é.
 */

import { useState, type ComponentProps, type ReactNode } from 'react';
import { duracaoDosDigitos, formatarDuracao, textoDosDigitos } from '@/shared/lib/duracao';
import { Campo } from './campo';

type PropsDoCampo = Omit<
  ComponentProps<typeof Campo>,
  'value' | 'onChange' | 'type' | 'inputMode' | 'min' | 'max'
>;

export function CampoDeDuracao({
  valorMs,
  aoMudar,
  ...props
}: PropsDoCampo & {
  /** A duração em milissegundos; nulo é zero. */
  valorMs: number | null;
  aoMudar: (ms: number) => void;
}): ReactNode {
  // Enquanto se digita, o texto é o que a pessoa vê; ao sair, ele se acerta.
  const [digitando, definirDigitando] = useState<string | null>(null);
  return (
    <Campo
      {...props}
      inputMode="numeric"
      autoComplete="off"
      spellCheck={false}
      placeholder="00:00:00"
      value={digitando ?? formatarDuracao(valorMs)}
      onChange={(e) => {
        const texto = textoDosDigitos(e.target.value);
        definirDigitando(texto);
        aoMudar(duracaoDosDigitos(texto));
      }}
      onBlur={() => definirDigitando(null)}
    />
  );
}
